export const entriesLimits: number[] = [10, 20, 50];

export enum IssueTableColumns {
  checkbox = 'checkbox',
  isNew = 'isNew',
  url = 'url',
  problem = 'problem',
  activity = 'activity',
  linkedTask = 'linkedTask',
  viewDetails = 'viewDetails',
  findingId = 'findingId',
}
